import React, { useCallback, useState } from 'react'
import { Link } from 'react-router-dom'
import { Modal, Typography } from 'antd'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { TASK_AWAITING_MESSAGES_CONFIG } from '../../constants'

const CurationTaskAwaitingModal = ({ status, redirectTo }) => {
  const [isVisible, setIsVisible] = useState(true)

  const handleClose = useCallback(() => {
    if (!TASK_AWAITING_MESSAGES_CONFIG[status]?.isCloseable) {
      return
    }

    setIsVisible(false)
  }, [status])

  if (isNil(status)) {
    return null
  }

  return (
    <Modal
      centered
      closable={TASK_AWAITING_MESSAGES_CONFIG[status]?.isCloseable}
      width="500px"
      title={TASK_AWAITING_MESSAGES_CONFIG[status]?.title}
      visible={isVisible}
      onCancel={handleClose}
      footer={null}
    >
      <Typography.Paragraph>
        {TASK_AWAITING_MESSAGES_CONFIG[status].description}
      </Typography.Paragraph>
      <Link target="_blank" to={redirectTo}>
        Go to curation tasks page
      </Link>
    </Modal>
  )
}

CurationTaskAwaitingModal.propTypes = {
  status: PropTypes.oneOf(
    'CURATION_PENDING',
    'DUPLICATE_PENDING',
    'IMPORT_PENDING',
    'HAS_TIMEOUT_ERROR',
    'HAS_UNCAUGHT_MENU_CURATOR_ERROR',
    'HAS_UNCAUGHT_AI_ERROR',
    'AWAITING_SCRAPING_REVIEW',
    'SCRAPING_REVIEW_IN_PROGRESS',
    'AWAITING_AUTOEAT_UPDATES',
  ),
  redirectTo: PropTypes.string.isRequired,
}

CurationTaskAwaitingModal.defaultProps = {
  status: null,
}

export default CurationTaskAwaitingModal
